export default "__VITE_ASSET__DtOFhiTa__"